import { useHistory } from 'react-router-dom';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
  pushSuccess,
} from 'src/utilities/notifications';

import { IErrorResponse } from 'src/utilities/shared-types';
import {
  DeactivateDinerFunctionProps,
  useDeactivateDiner,
} from 'src/common/features/DinersManagement/hooks/useDeactivateDiner';

export type UseDeactivateParentAccountAdminReturn = {
  deactivate: (props: DeactivateDinerFunctionProps) => Promise<void>;
  isLoading: boolean;
};

export const useDeactivateParentAccountAdmin =
  (): UseDeactivateParentAccountAdminReturn => {
    const { push } = useHistory();

    const handleSuccess = async ({
      corpId,
      diner: { first_name },
    }: DeactivateDinerFunctionProps) => {
      pushSuccess(`${first_name} has been deactivated.`);

      const parentOverviewLink = `/corporate/enterprise/parents/${corpId}/admin`;

      push(parentOverviewLink);
    };

    const handleError = (error?: IErrorResponse | SdkErrorResponse) => {
      pushErrorFromAPI(error, {
        fallbackMessage: "Couldn't deactivate admin. Try again.",
      });
    };

    const { deactivate, isLoading } = useDeactivateDiner({
      onSuccess: handleSuccess,
      onError: handleError,
    });

    return {
      deactivate,
      isLoading,
    };
  };
